import { useFormContext } from 'react-hook-form';
import { KEYWORD_INPUT_ID } from '../../constants';
import { useSearchContext } from '../../context/Search';

const useSearchAreaSuggestionsLogic = () => {
  const {
    searchAreaSuggest: { searchAreaSuggestions },
    selectedSearchArea: [, setSelectedSearchArea],
  } = useSearchContext();
  const { setFocus } = useFormContext();

  /**
   * When user clicks a search area suggestion, save it as the selected search area and move focus to the
   * keyword input.
   * @param {Object} suggestion A suggested search area
   * @returns {void}
   */
  const handleSuggestionClick = suggestion => {
    setSelectedSearchArea(suggestion);
    setFocus(KEYWORD_INPUT_ID);
  };

  return {
    handleSuggestionClick,
    suggestions: searchAreaSuggestions,
  };
};

export default useSearchAreaSuggestionsLogic;
